import { useRef } from "react";
import { Paperclip, Trash2, FileDown } from "lucide-react";

const size = (bytes) => (bytes > 1024 * 1024
  ? `${(bytes / 1024 / 1024).toFixed(1)}MB`
  : `${Math.max(1, Math.round(bytes / 1024))}KB`);

export const Attachments = ({ event, accent, busy, onUpload, onOpen, onDelete }) => {
  const picker = useRef(null);

  return (
    <div className="mt-1.5 flex flex-wrap items-center gap-2" data-testid={`attachments-${event.event_id}`}>
      {(event.attachments || []).map((a) => (
        <span key={a.att_id} className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-page px-2.5 py-1 text-xs">
          <button
            data-testid={`attachment-open-${a.att_id}`}
            onClick={() => onOpen(a)}
            className="inline-flex items-center gap-1.5 text-ink-soft hover:text-ink"
          >
            <FileDown className="h-3 w-3" /> {a.name} <span className="opacity-60">{size(a.size)}</span>
          </button>
          <button
            data-testid={`attachment-delete-${a.att_id}`}
            onClick={() => onDelete(event, a)}
            aria-label={`Remove ${a.name}`}
            className="text-ink-soft hover:text-destructive"
          >
            <Trash2 className="h-3 w-3" />
          </button>
        </span>
      ))}
      <input
        ref={picker}
        type="file"
        accept=".pdf,.png,.jpg,.jpeg,.webp,.txt,.csv,.docx,.xlsx"
        className="hidden"
        data-testid={`attachment-input-${event.event_id}`}
        onChange={(e) => {
          const file = e.target.files?.[0];
          e.target.value = "";
          if (file) onUpload(event, file);
        }}
      />
      <button
        data-testid={`attachment-add-${event.event_id}`}
        onClick={() => picker.current?.click()}
        disabled={busy}
        className="inline-flex items-center gap-1 rounded-full border border-white/10 px-2.5 py-1 text-xs text-ink-soft transition-colors hover:text-ink"
        style={{ borderColor: busy ? accent : undefined }}
      >
        <Paperclip className="h-3 w-3" /> {busy ? "Uploading…" : "Attach a file"}
      </button>
    </div>
  );
};
